import Viewports from "../../components/fsUtils/Viewports";

class TopVideoPlayer {

    constructor() {
        this.videoLinks = document.querySelectorAll('.top-videos-link');

        this.addClickListeners();

		/**
		* Video loading functionality
		*/

		// Setting and caching some variables
		var viewports = new Viewports();
		var videEmbeds = document.querySelectorAll( '.video-embed' );

		// If there are no embeds on the page, bail out
		if ( ! videEmbeds ) {
			return;
		} // if

		var videEmbedsCount = videEmbeds.length;
		var dataUrl;
		var dataMobile;
		var videoObj;
		var iframe;
		var j;

		// Loop though all the embeds (there's probably just 1, but just to be safe)
		if ( videEmbedsCount ) {
			for ( j = 0; j < videEmbedsCount; j = j + 1 ) {

				videoObj = videEmbeds[j];
				dataUrl = videoObj.getAttribute( 'data-video' );
				dataMobile = videoObj.getAttribute( 'data-mobile' );

				// Make sure there's a data attr set before continuing (it's only required if you want to load the video with JS)
				if ( dataUrl ) {

					// If the mobile hide option is checked and this is a phone, hide the component
					if ( dataMobile === 'hide' && this.isMobile() ) {

						// Remove the Component HTML since we don't need it (and the iframe was never created)
						videoObj.parentElement.removeChild( videoObj );

					} else {

						// Create the iframe
						iframe = document.createElement( 'iframe' );
						iframe.src = dataUrl;
						iframe.setAttribute( 'frameborder', '0' );
						iframe.id = 'video_frame'

						// Put the iframe where we need it
						videoObj.appendChild( iframe );

					}

				} else {

					// If there's no URL set, just remove the component so it doesn't look weird
					videoObj.parentElement.removeChild( videoObj );

				} // if dataUrl

			} // for
		} // if

    } // constructor

    getPlayerVideoTitle() {

        let playerVideoTitleElm = document.querySelector('.titlebar_fg .title');
        if (playerVideoTitleElm !== null) {
            return playerVideoTitleElm.innerHTML;
        }
        return null;

    } // getPlayerVideoTitle()


    updateTopVideoPlayer( event ) {

        event.preventDefault();

        let elem = event.currentTarget;
        let releaseUrl = elem.getAttribute('data-release') + elem.getAttribute('data-iu');

        if (fdmPlayer !== 'undefined' && fdmPlayer instanceof Array) {

            fdmPlayer[0].setReleaseCall(releaseUrl);
        }

    } // updateTopVideoPlayer()

    addClickListeners() {

        let videos = this.videoLinks;
        let count = videos.length;

        for (let i = 0; i < count; i += 1) {
            videos[i].addEventListener('click', this.updateTopVideoPlayer.bind(this));
        }

    } // addClickListeners()

	/*
	* A small, userAgent-based mobile detection script
	*/
	isMobile() {

		if ( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) {

			return true;

		} else {

			return false;

		}

	} // isMobile()

} // TopVideoPlayer

export default TopVideoPlayer;



// WEBPACK FOOTER //
// ./assets/components/platformPlayer/TopVideoPlayer.js